import * as Reducer from './slice';

export interface IAppState {
  // this feature state
  [Reducer.statePropName]: Reducer.IOrdersPageState;
}

const getPageState = (state: IAppState) => state[Reducer.statePropName];

export const isStarted = (state: IAppState) => getPageState(state).started;

export const getOrders = (state: IAppState) => getPageState(state).orders;
